import {
  selectOrganizationId,
  selectUserProjectId,
  selectUserProjectIsUuidBased,
  selectUserProjectName,
  selectUserProjectToken,
  selectUserProjectUuidProjectType,
} from 'core/userContext';
import { selectAllOrganizationsList } from 'modules/allOrganizations';
import { useSelector } from 'react-redux';

export const useProjectMetadata = () => {
  /** Org info */
  const orgID = useSelector(selectOrganizationId);

  /**
   * Organizations
   * Used to get info for the current organization not provided in the user context
   */
  const organizations = useSelector(selectAllOrganizationsList);
  const org = !!orgID ? organizations[orgID] : null;
  const clusterId = org?.clusterId;
  const cluserIndex = useSelector(selectUserProjectToken);

  /** Project info */
  const projectName = useSelector(selectUserProjectName);
  const projectID = useSelector(selectUserProjectId);
  const uuidBased = useSelector(selectUserProjectIsUuidBased);
  const uuidProjectType = useSelector(selectUserProjectUuidProjectType);
  /**
   * @see https://github.com/Iterable/iterable/blob/a9f069487aff18077a9c1d9379a873750f0d8051/platform/app/com/iterable/projects/models/UuidProjectType.scala#L18-L20
   */
  const isHybrid = uuidProjectType === 0;
  const hybridText = isHybrid
    ? 'Hybrid project (unique userId and unique email)'
    : 'UserID-based project (unique userId)';

  const uuidBasedSentence = uuidBased ? hybridText : 'Email-based project (unique email)';

  const projectData = [
    `Project Name: ${projectName}`,
    `Project ID: ${projectID}`,
    `Organization ID: ${orgID}`,
  ];

  const orgData = org ? [`ES Index: ${cluserIndex}`, `ES Cluster ID: ${clusterId}`] : [];

  const metaData = [...projectData, `${uuidBasedSentence}`, ...orgData];

  return metaData;
};
